class btnQuantity extends HTMLElement {
  constructor() {
    super();

    // guardar handler ligado una sola vez
    this.onNewCartRefresh = this.renderElement.bind(this);
  }

  connectedCallback() {
    this.btnLess = this.querySelector('[data-event-less]');
    this.btnMore = this.querySelector('[data-event-more]');
    this.quantityEl = this.querySelector('[data-quantity]');
    this.inputQuantity = this.querySelector('input[name="quantity"]');
    this.dataStock = this.inputQuantity.dataset.stock;
    this.dataCartQuantity = this.inputQuantity.dataset.cartQuantity;

    this.initEvents();
  }

  disconnectedCallback() {
    // quitar listener global cuando el elemento se saca del DOM
    document.removeEventListener('pb:cart:refresh', this.onNewCartRefresh);
  }

  initEvents() {
    if (this.btnLess) this.btnLess.addEventListener('click', this.handleLess.bind(this));
    if (this.btnMore) this.btnMore.addEventListener('click', this.handleMore.bind(this));
    document.addEventListener('pb:cart:refresh', this.onNewCartRefresh);
  }

  handleLess() {
    const newQuantity = Number(this.inputQuantity.value) - 1;
    if (newQuantity < 1) return;

    this.querySelector('.stock-message').classList.add('hidden');
    this.btnMore.disabled = false;

    this.quantityEl.textContent = newQuantity;
    this.inputQuantity.value = newQuantity;
  }

  handleMore() {
    const newQuantity = Number(this.inputQuantity.value) + 1;

    if(newQuantity > this.dataStock || newQuantity > (this.dataStock - this.dataCartQuantity)){
      this.querySelector('.stock-message').classList.remove('hidden');
      this.btnMore.disabled = true;
      return;
    }

    this.quantityEl.textContent = newQuantity;
    this.inputQuantity.value = newQuantity;
  }

  renderElement(){
    const sectionData = this.dataset.sectionId;
    const sectionId = sectionData.replace('btn-quantity-', '');

    const url = new URL(window.location.href);         // conserva pathname + query + hash
    url.searchParams.set('sections', sectionId);       // añade/sobrescribe solo "sections"

    fetch(url.toString())
      .then(res => res.json())
      .then(data => {
        const tmpMainSection = document.createElement('div');
        tmpMainSection.innerHTML = data[sectionId];
       
        const newBtnQuantity = tmpMainSection.querySelector(`[data-section-id='btn-quantity-${sectionId}']`);
        const oldBtnQuantity = document.querySelector(`[data-section-id='btn-quantity-${sectionId}']`);

        if (newBtnQuantity && oldBtnQuantity) {
          oldBtnQuantity.replaceWith(newBtnQuantity);
        }

      })
      .catch(err => {
        console.error('Error:', err);
      });
  }
}
customElements.define('btn-quantity', btnQuantity);